import {Kpis} from '../Interfaces/Kpis';

const ProgressState: Kpis[] = [];

export default ProgressState;
